<template>
  <div class="body">
    <div class="dh">
      <div
        style="
          width: 356px;
          min-height: 990px;
          border-right: 20px solid#F2F2F2;
          display: flex;
          flex-direction: column;
          background-color: #ffffff;
        "
      >
        <div
          style="
            width: 336px;
            height: 70px;
            background-color: #015293;
            padding: 20px;
            display: flex;
            flex-direction: row;
          "
        >
          <div class="div1" style="background-color: #ffffff"></div>
          <h1
            style="
              width: 200px;
              height: 18px;
              font-size: 18px;
              font-weight: bold;
              color: #ffffff;
            "
          >
            文 献 索 引
          </h1>
        </div>
        <div
          class="style5"
          v-for="(item, i) in items"
          :key="i"
          :class="{ bgcolor: i == current }"
        >
          <br />
          <div id="tb"></div>
          <span @click="tochild(item, i)" class="cursor">{{ item.title }}</span>

          <br />
        </div>
      </div>
      <div style="background-color: white; width: 848px; padding: 66px 64px">
        <div v-html="html"></div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" >
import { mapState, mapActions } from "vuex";
export default {
  name: "wxsy",

  data() {
    return {
      items: [],
      html: "",
      current: "",
    };
  },
  computed: {
    ...mapState({
      content: (state) => state.wxsy.content,
    }),
  },
  created() {
    this.$emit("hbhead", 5);
    this.$axios.get("/get_list?type=5").then((Response) => {
      this.items = Response.data.data.list
      if (!sessionStorage.getItem("wxsy")) {
        this.html = this.items[0].content;
        this.current = 0;
      } else {
        this.html = this.items[sessionStorage.getItem("wxsy")].content;
        this.current = sessionStorage.getItem("wxsy");
      }
    });
  },
  methods: {
    tochild(data, i) {
      this.html = data.content;
      this.current = i;
      this.$store.commit("wxsy", {
        content: i,
      });
      sessionStorage.setItem("wxsy", this.content);
    },
  },
};
</script>
<style scoped>
.body {
  background-color: #f2f2f2;
}

.dh {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
}
.cursor {
  cursor: pointer;
}
.style5 {
  width: 336px;
  display: flex;
  flex-direction: row;
  padding: 15px;
}

#tb {
  height: 8px;
  width: 8px;
  background: linear-gradient(to left, #015293, #015293) no-repeat left top,
    linear-gradient(to left, #015293, #015293) no-repeat right top,
    linear-gradient(to left, #015293, #015293) no-repeat left bottom,
    linear-gradient(to left, #015293, #015293) no-repeat right bottom, #ffffff;
  background-size: 2px 3px, 4px 3px, 2px 3px, 4px 3px;
  margin-top: 7px;
  margin-right: 5px;
}
.div1 {
  width: 3px;
  height: 15px;
  line-height: 50px;
  background: #ffffff;
  text-align: center;
  margin-top: 5px;
  margin-right: 5px;
}
.bgcolor {
  background-color: #e1edfa;
}
</style>